import React, { useState, useEffect } from 'react';
// import "@reach/dialog/styles.css";
import '../css/modal.css';
import { CenterModal } from 'react-spring-modal';
import { useRecoilValue } from 'recoil';
import { translatedText } from '../recoil-states/language-state';

export default function StakeModal({
	onClick,
	modalVisible,
	_setModalVisible,
}) {
	const textData = useRecoilValue(translatedText);
	const [checkAnswer, setCheckAnswer] = useState(false);
	useEffect(() => {
		setCheckAnswer(false);
	}, []);
	useEffect(() => {
		setTimeout(() => {
			setCheckAnswer(false);
		}, 500);
	}, [modalVisible]);
	return (
		<div id='StakeModal col'>
			<CenterModal
				isOpen={modalVisible}
				onDismiss={() => _setModalVisible(false)}
				contentProps={{ style: apllyModalstyle }}
			>
				{textData && (
					<div className='StakeModal_container'>
						<p>
							{textData.StakeModal.maintext.replaceAll(
								'<br/>',
								'\n\r'
							)}
						</p>
						<div className='StakeModal_btnBox'>
							<button
								onClick={() => {
									onClick();
								}}
								className='Stake_btn_yes'
							>
								<p>Yes</p>
							</button>
						</div>
					</div>
				)}
			</CenterModal>
		</div>
	);
}
const apllyModalstyle = {
	backgroundColor: '#22262B',
	zIndex: '5',
	width: '100%',
	border: '1px solid #CCCCCC',
	animation: 'none',
	overflow: 'hidden',
};
